import React from 'react';
import { uniqueId } from '../../utils/helpers';
import PdpHeaderShopify from './pdpHeaderShopify';
const getPlantSize = (data) => {
    let height;
    let width;
    if (data.plant_size) {
        if (data.plant_size.height) {
            height = (React.createElement("li", null,
                "H:",
                ' ',
                data.plant_size.height));
        }
        if (data.plant_size.width) {
            width = (React.createElement("li", null,
                "W:",
                ' ',
                data.plant_size.width));
        }
        return (React.createElement("ul", { className: "pdp_details__list pdp_details__list-size" },
            height,
            width));
    }
    return null;
};
const getZones = (data) => {
    if (data.zones) {
        const { zones } = data;
        return (React.createElement("ul", { className: "pdp_details__list pdp_details__list-zones" },
            React.createElement("li", null, zones)));
    }
    return null;
};
const PdpHeader = ({ photos, addToShopifyCart, shopifyVariants, partnersData, alias, title, scientificName, djangoPk, affiliatedLinks, plantData, isForSale, }) => {
    let headerClass = 'pdp_header';
    let aliases = null;
    let scientificNameEl = null;
    let buyBtn = null;
    const photo = photos.length > 0 ? photos[0] : null;
    headerClass += isForSale ? ' isForSale' : '';
    buyBtn = (React.createElement(PdpHeaderShopify, { djangoPk: djangoPk, onAddToShopifyCart: addToShopifyCart, variants: shopifyVariants.filter((item) => item.available), title: title, partnersData: partnersData, isForSale: isForSale, affiliatedLinks: affiliatedLinks }));
    if (alias && alias.length > 0) {
        const allAliases = alias.map((item) => React.createElement("li", { key: uniqueId(item) }, item));
        aliases = (React.createElement("div", { className: "pdp_header__aliases_container" },
            React.createElement("h3", null, "Also Known As"),
            React.createElement("ul", { className: "pdp_header__aliases" }, allAliases)));
    }
    if (scientificName !== null) {
        scientificNameEl = (React.createElement("p", { className: "pdp_header__scientific_name" },
            "Scientific Name:",
            ' ',
            scientificName));
    }
    let photoContributorName = null;
    if (photo) {
        photoContributorName = (React.createElement("span", { className: "carousal_attr_title" }, photo.contributor_info.name ? photo.contributor_info.name : 'Unknown'));
        if (photo.contributor_info.is_nursery && photo.contributor_info.active) {
            const nurseryLink = `/nurseries/${encodeURIComponent(photo.contributor_info.slug)}/`;
            photoContributorName = (React.createElement("a", { href: nurseryLink, rel: "noopener noreferrer" },
                React.createElement("span", { className: "carousal_attr_title link" }, photo.contributor_info.name ? photo.contributor_info.name : 'Unknown')));
        }
    }
    return (React.createElement("header", { className: headerClass },
        React.createElement("div", { className: "pdp_header__images" }, photo ? (React.createElement("div", { className: "pdp_header__image" },
            React.createElement("div", { className: "submission_pres" },
                React.createElement("a", { href: "#photo-gallery" },
                    React.createElement("picture", null,
                        React.createElement("source", { type: "image/webp", srcSet: photo.photo_webp }),
                        React.createElement("source", { type: "image/jpeg", srcSet: photo.photo }),
                        React.createElement("img", { src: photo.photo, alt: photo.alt })))),
            React.createElement("div", { className: "submission_text no_min_height", style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: '10px',
                } },
                React.createElement("div", { className: "attribution" },
                    React.createElement("p", null,
                        React.createElement("span", { className: "carousal_attr" }, "Photo by "),
                        photoContributorName),
                    React.createElement("p", { className: "small" }, photo.copyright_info)),
                React.createElement("a", { href: "#photo-gallery", className: "btn neutral show_all_photos" }, "Show all photos")))) : (React.createElement("div", { className: "pdp_header__no-image" },
            React.createElement("img", { src: `${process.env.STATIC_PATH}/img/placeholder_plant_photo.svg`, alt: "Placeholder" })))),
        React.createElement("div", { style: title ? { minHeight: 60 } : { minHeight: 130 }, className: "pdp_header__text" },
            React.createElement("h1", null,
                isForSale ? 'Buy ' : '',
                title),
            scientificNameEl,
            aliases),
        React.createElement("div", { className: "pdp_header__detail" },
            React.createElement("div", { className: "pdp_details__1" },
                React.createElement("div", { className: "column plant_type" },
                    React.createElement("h3", { className: "pdp_plant__type" }, "Plant type"),
                    React.createElement("p", { className: "pdp_details__list pdp_details__list-type" }, plantData.get_plant_types.join(', '))),
                React.createElement("div", { className: "column size" },
                    React.createElement("h3", { className: "pdp_plant__size" }, "size"),
                    getPlantSize(plantData)),
                React.createElement("div", { className: "column zone" },
                    React.createElement("h3", { className: "pdp_plant__zone" }, "planting zones"),
                    getZones(plantData))),
            buyBtn)));
};
export default PdpHeader;
